<template>
  <div>
    <div class="topbar">
      <div class="brand" @click="$router.back()">&#8249; 预咨询</div>
    </div>
    <div class="content">
      <div class="card">
        <div class="row">
          <div style="font-weight: 600; font-size: 17px">{{ query.title }}</div>
          <div class="price">¥{{ (query.price / 100).toLocaleString("zh-CN") }}</div>
        </div>
        <div class="muted" style="margin-top: 6px">
          {{ query.expertName }}
          <template v-if="query.durationText"> · {{ query.durationText }} 分钟</template>
        </div>
        <div class="rich-content" style="margin-top: 12px" v-if="query.description" v-html="sanitizeRichText(query.description)"></div>
      </div>

      <div class="muted" style="font-size: 13px; text-align: center; margin: 12px 0">
        支付完成后，可以在订单详情里补充选题方向、上传稿件，方便专家更好地为你服务
      </div>

      <button class="btn" :disabled="submitting" @click="submit" v-track="'NRCU006|NRCU006-002|点击下一步去支付'">
        {{ submitting ? "提交中..." : "下一步，去支付 ¥" + (query.price / 100).toLocaleString("zh-CN") }}
      </button>
    </div>
  </div>
</template>

<script>
import { orderCreate } from "@/api/nrc.js";
import { Toast } from "vant";
import { sanitizeRichText } from "@/utils/richText.js";

export default {
  name: "OrderCreate",
  data() {
    return {
      query: {},
      submitting: false,
    };
  },
  created() {
    this.query = this.$route.query;
  },
  methods: {
    sanitizeRichText,
    submit() {
      this.submitting = true;
      orderCreate({
        slotId: this.query.slotId,
        referralVisitToken: this.query.referralVisitToken,
      })
        .then((order) => {
          this.$router.replace("/order/" + order.id);
        })
        .catch(() => {
          Toast("提交失败，请重试");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>
